<template>
  <div class="DoorColorCost">
    <ATable
      ref="table"
      :data="items"
      max-height="722px"
      highlight-current-row
      hide-button-insert
      border
      hide-top-panel
      hide-pagination
      @cell-click="handleCellClick"
    >
      <el-table-column
        type="index"
        label="No"
        :index="handleIndex"
        :width="$width.indexw"
      />
      <el-table-column prop="product_name" label="품목명" />
      <el-table-column
        width="100"
        class-name="cell-number"
        v-for="color in table_door_color"
        :key="color.id"
        :label="color.name"
        :prop="'color_' + color.id"
      >
        <template slot-scope="scope">
          <div v-if="scope.row[color.id] !== undefined">
            <div v-if="scope.row.id === editingId">
              <ANumberInput
                v-model="scope.row[color.id]"
                :disabled="!has_grant_write"
              />
            </div>
            <div v-else>
              {{ util.addComma(scope.row[color.id]) }}
            </div>
          </div>
          <div v-else>
            &nbsp;
          </div>
        </template>
      </el-table-column>
      <el-table-column label="명령" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <el-button
              type="primary"
              size="mini"
              :disabled="!has_grant_write"
              :loading="load_button"
              @click="handleClickRegister(scope.row)"
              >저장</el-button
            >
            <el-button size="mini" @click="handleClickCancel(scope.row)"
              >취소</el-button
            >
          </div>
          <div v-else>
            &nbsp;
          </div>
        </template>
      </el-table-column>
    </ATable>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "DoorColorCost",
  data() {
    return {
      title: this.$t("title.door_color_cost"),
      editingId: 0,
      oldItem: null,
      load_button: false,
    };
  },
  props: {
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "table_product",
      "table_door_color",
      "table_product_door_color_price",
    ]),
    items() {
      let items = [];
      let id = 1;
      this.table_product_door_color_price.forEach((e) => {
        let item = items.find((item) => item.product_id === e.product_id);
        if (item) {
          item[e.door_color_id] = e.price ? e.price : 0;
        } else {
          let product = this.table_product.find((p) => p.id === e.product_id);
          item = {
            id: id++,
            product_id: e.product_id,
            product_name: product?.name,
          };
          item[e.door_color_id] = e.price ? e.price : 0;
          items.push(item);
        }
      });
      return items;
    },
  },
  methods: {
    doRegister(item) {
      let items = [];
      this.table_door_color.forEach((c) => {
        if (item[c.id] !== undefined) {
          items.push({
            product_id: item.product_id,
            door_color_id: c.id,
            price: item[c.id],
          });
        }
      });
      if (items.length < 1) {
        return;
      }
      this.load_button = true;
      this.api.registerProductDoorColorPrice(items).then((res) => {
        this.load_button = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.editingId = 0;
        this.util.notify_success(
          this,
          this.title,
          this.$t("message.success_register")
        );
      });
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleCellClick(item, column) {
      if (!column.property) {
        return;
      }
      if (this.editingId === item.id) {
        return;
      }
      if (this.editingId > 0) {
        this.handleClickCancel(this.oldItem);
      }
      this.editingId = item.id;
      this.oldItem = Object.assign({}, item);
    },
    handleClickRegister(item) {
      this.doRegister(item);
    },
    handleClickCancel(item) {
      let index = this.items.findIndex((i) => i.id === item.id);
      if (this.oldItem.id) {
        this.items.splice(index, 1, this.oldItem);
      } else {
        this.items.splice(index, 1);
      }
      this.editingId = 0;
    },
  },
};
</script>
